<ng-container *ngIf="addressBookEntry">

    <div class="row" >
        <div class="col-md-12 col-lg-6">
            <div class="row">
                <div class="col-sm-10">

                    <div class="smp-title-thin-border mb-3">{{ 'address_book_management.title.general' | translate }}</div>

                    <gender-twb [(bananaBox)]="addressBookEntry.gender" [idPrefix]="idPrefix + 'participant.'"></gender-twb>

                    <div class="row no-gutters">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{ addressBookEntry.trans.name1 | translate }}</mat-label>
                                <input id="{{idPrefix}}input_text.{{addressBookEntry.trans.name1}}"
                                       type="text" matInput
                                       [(ngModel)]="addressBookEntry.name1"
                                       [disabled]="disabled">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{ addressBookEntry.trans.name2 | translate }}</mat-label>
                                <input id="{{idPrefix}}input_text.{{addressBookEntry.trans.name2}}"
                                       type="text" matInput
                                       [(ngModel)]="addressBookEntry.name2"
                                       [disabled]="disabled">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>{{ addressBookEntry.trans.name3 | translate }}</mat-label>
                                <input id="{{idPrefix}}input_text.{{addressBookEntry.trans.name3}}"
                                       type="text" matInput
                                       [(ngModel)]="addressBookEntry.name3"
                                       [disabled]="disabled">
                            </mat-form-field>
                        </div>
                    </div>

                    <address-twb [(bananaBox)]="addressBookEntry.address" [idPrefix]="idPrefix"></address-twb>

                    <div class="mt-2">
                        <app-boolean-toggle class="full-width"
                                            [inputLabel]="addressBookEntry.trans.tax_deduction"
                                            [idPrefix]="idPrefix + addressBookEntry.trans.tax_deduction"
                                            [(trueFalseNull)]="addressBookEntry.tax_deduction">
                        </app-boolean-toggle>
                    </div>
                    
                </div>
                <div class="col-sm-2">
                    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
                </div>
            </div>
        </div>

        <div class="col-md-12 col-lg-6">

            <div class="row">
                <div class="col-sm-10">

                    <div class="smp-title-thin-border mb-3">{{ addressBookEntry.address.trans.contacts | translate }} </div>

                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">

                    <contacts-twb [(bananaBox)]="addressBookEntry.address.contacts" [idPrefix]="idPrefix"></contacts-twb>

                </div>
            </div>

            <div class="row">
                <div class="col-sm-10">
                    <mat-form-field class="full-width mt-3">
                        <mat-label>{{ addressBookEntry.trans.cost_center | translate }}</mat-label>
                         <input id="{{idPrefix}}input_text.{{addressBookEntry.trans.cost_center}}"
                                       type="text" matInput
                                       [(ngModel)]="addressBookEntry.cost_center"
                                       [disabled]="!!disabled">
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-10">
                    <mat-form-field class="full-width mt-3">
                        <mat-label>{{ addressBookEntry.trans.comment | translate }}</mat-label>
                        <textarea id="{{idPrefix}}input_textarea.{{addressBookEntry.trans.comment}}"
                                  matInput
                                  rows="7"
                                  [(ngModel)]="addressBookEntry.comment">
                        </textarea>
                    </mat-form-field>
                </div>
            </div>

        </div>
    </div>

    <div class="row mt-5">

        <div class="offset-lg-6 col-xs-12 col-md-6 col-lg-3">
            <a id="{{idPrefix}}btn.cancel"
               mat-stroked-button
               color="primary"
               class="full-width"
               (click)="cancel()">
                {{ 'common.btn.cancel' | translate | uppercase }}
            </a>
        </div>

        <div class="col-xs-12 col-md-6 col-lg-3">
            <button id="{{idPrefix}}btn.save"
                    mat-flat-button
                    color="accent"
                    class="full-width"
                    (click)="submit()">
                {{ 'common.btn.save' | translate | uppercase }}
            </button>
        </div>

    </div>

</ng-container>
